import { createQueryKeys } from '@lukemorales/query-key-factory';

import { aimsApi } from '@/axios/AclosetApi';

export const 샵_정보_쿼리키 = createQueryKeys('샵_정보_쿼리키', {
  컬러태그_조회: ({ shopID }: { shopID: string }) => ({
    queryKey: [shopID] as const,
    queryFn: () => {
      return aimsApi.shops.colorTagsDetail(shopID).then(v => v.data);
    },
  }),
});
